export enum ROLE {
  NFL_ADMIN = 'Admin',
  CLUB_ADMIN = 'Club Admin',
}

export interface UserDetails {
  email: string;
  email_verified: string;
  family_name: string;
  given_name: string;
  identities: string;
  name: string;
  sub: string;
  updated_at: string;
  userId: string;
  username: string;
}
